import { render, staticRenderFns } from "./Organization.vue?vue&type=template&id=0f8f91fa&scoped=true"
import script from "./Organization.vue?vue&type=script&lang=js"
export * from "./Organization.vue?vue&type=script&lang=js"
import style0 from "./Organization.vue?vue&type=style&index=0&id=0f8f91fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8f91fa",
  null
  
)

export default component.exports